module.exports = __webpack_public_path__ + "img/Food.638a2a93.jpg";